module.exports = __webpack_public_path__ + "static/img/Gacha11.65a7694.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/gasha/Gacha11.png
// module id = JNk3
// module chunks = 1